<div class="dropdown">
  <div
    #dropdown
    [ngClass]="dropdownClass()"
    [class.dropdown-menu]="!toggleSubmenu"
    [class.show]="isOpen"
    [class.dropup-menu]="dropup"
    (click)="close()"
    [style]="customCssProps"
  >
    <ng-content></ng-content>
  </div>
</div>

<!-- Full screen overlay to catch clicks outside of the dropdown -->
<div class="overlay" (click)="close()" *ngIf="isOpen"></div>
